
import {
    createUserWithEmailAndPassword,
    signInWithPopup,
    GoogleAuthProvider,
    signOut,
    signInWithEmailAndPassword,
    sendPasswordResetEmail,
    deleteUser,
} from 'firebase/auth'

import { auth } from './FirebaseConfig';
import { createUser } from './database/Users';
import { checkIfUserExistWithEmail } from './database/Users';

export const registerWithEmail = async (email, password) => {
    try {
        const user = await createUserWithEmailAndPassword(auth, email, password)
        let uid = user.user.uid
        let createdAt = user.user.metadata.createdAt

        await createUser(uid, email, createdAt, 'local')
    } catch (error) {
        throw error
    }
}

export const registerWithGoogle = async () => {
    try {
        const provider = new GoogleAuthProvider;
        const user = await signInWithPopup(auth, provider).catch(error => { throw error })

        let uid = user.user.uid
        let email = user.user.email
        let createdAt = user.user.metadata.createdAt

        let userExist = await checkIfUserExistWithEmail(email)

        if (!userExist) {
            await createUser(uid, email, createdAt, 'google')
        }

    } catch (error) {
        throw error
    }
}

export const loginWithEmail = async (email, password) => {
    await signInWithEmailAndPassword(auth, email, password)
        .catch(error => {
            throw error
        })
}

export const logout = async () => {
    await signOut(auth)
}

export const resetPasswordByEmail = async (email) => {
    await sendPasswordResetEmail(auth, email)
}

export const deleteUserAccount = async () => {
    const user = auth.currentUser;

    await deleteUser(user)
        .catch(err => {
            throw new Error()
        })
}